import { render, staticRenderFns } from "./global_search_no_results.vue?vue&type=template&id=e1415394"
import script from "./global_search_no_results.vue?vue&type=script&lang=js"
export * from "./global_search_no_results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports